<template>
  <v-list class="the-navigation__list" dark dense>
    <v-list-item class="py-2" dark>
      <v-list-item-content
        dark
        class="the-navigation__org_select"
        :class="{ _mini: isNavDrawerMiniVariant }"
      >
        <v-select
          v-model="activeOrganisation"
          @input="setActiveOrganisation"
          :items="organisations"
          item-text="name"
          :menu-props="{ bottom: true, offsetY: true }"
          item-value="id"
          :disabled="isNavDrawerMiniVariant"
          color="darken-3"
          class="myOrgSelect"
          hide-details
          filled
          dark
          dense
        >
          <template v-slot:item="{ item }">
            <span class="org_select" dark>
              <img
                :src="item.logo"
                alt=""
                class="the-navigation__img_logo"
                v-if="item.logo != null"
              />
              <v-icon
                v-else-if="item.id == 0"
                class="the-navigation__img_logo"
                color="orange"
                medium
              >
                mdi-account-box
              </v-icon>
              <avatar
                v-else
                class="the-navigation__img_logo"
                :rounded="false"
                :initials="initials(item.name)"
                :username="item.name"
                :size="24"
                :customStyle="{
                  display: 'inline-block',
                  borderRadius: '4px',
                  fontSize: '11px',
                }"
              />
              <span class="the-navigation__item_name"> {{ item.name }} </span>
              <v-icon
                v-if="item.id == organisationId"
                color="orange"
                style="float: right; margin-top: 4px"
                dark
                small
              >
                mdi-checkbox-marked-circle
              </v-icon>
            </span>
          </template>
          <template v-slot:selection="{ item, index }">
            <span class="org_select" dark>
              <img
                :src="item.logo"
                alt=""
                class="the-navigation__img_logo"
                v-if="item.logo != null"
              />
              <v-icon
                v-else-if="item.id == 0"
                class="the-navigation__img_logo"
                color="orange"
                medium
              >
                mdi-account-box
              </v-icon>
              <avatar
                v-else
                class="the-navigation__img_logo"
                :rounded="false"
                :initials="initials(item.name)"
                :username="item.name"
                :size="24"
                :customStyle="{
                  display: 'inline-block',
                  borderRadius: '4px',
                  fontSize: '11px',
                }"
              />

              <span class="the-navigation__item_name"> {{ item.name }} </span>
            </span>
          </template>

          <template v-slot:append-item v-if="canCreateOrg">
            <v-divider class="mb-2"></v-divider>
            <v-list-item dark @click="createOrganisation">
              <v-list-item-icon>
                <v-icon dark> mdi-plus </v-icon>
              </v-list-item-icon>
              <v-list-item-content dark class="add-org-content"> 
                <div class="add-org-wrapper">
                  <span class="add-org-text">Create Team Workspace</span>
                  <v-tooltip v-if="!canActuallyCreateOrg" top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon 
                        v-bind="attrs" 
                        v-on="on"
                        class="upgrade-icon"
                        color="#ff7e21"
                        size="16"
                      >
                        mdi-arrow-up-bold-circle-outline
                      </v-icon>
                    </template>
                    <span>Available on paid plans</span>
                  </v-tooltip>
                </div>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-select>
      </v-list-item-content>
    </v-list-item>

    <v-list-item
      v-if="orgSettingsAvailable"
      link
      :to="{ name: 'organisation_main', params: { id: this.organisationId } }"
      class="the-navigation__list-item"
      active-class="_active"
    >
      <v-list-item-icon :class="{ 'mr-3': !isNavDrawerMiniVariant }">
        <v-icon class="the-navigation__nav-icon">settings </v-icon>
      </v-list-item-icon>

      <v-list-item-content class="the-navigation__nav-content">
        Company Settings
      </v-list-item-content>
    </v-list-item>

    <v-divider />

    <div class="the-navigation__projects-header">
      <div
        class="projects-title"
        @mouseenter="showSearchIcon = true"
        @mouseleave="showSearchIcon = false"
      >
        <v-icon
          class="projects-icon"
          :class="{ 'mr-2': !isNavDrawerMiniVariant }"
          >mdi-layers</v-icon
        >
        <span v-if="!isSearching">Your Projects</span>
        <span v-if="!isSearching && showSearchIcon" class="search-trigger">
          <v-icon small @click.stop="startSearch"> mdi-magnify </v-icon>
        </span>
      </div>
      <v-slide-x-transition>
        <div v-if="isSearching" class="search-container">
          <v-text-field
            v-model="searchQuery"
            dense
            dark
            hide-details
            placeholder="Search sites..."
            class="search-input"
            @blur="onSearchBlur"
            ref="searchInput"
          >
            <template v-slot:prepend>
              <v-icon small color="#A4A4AE">mdi-magnify</v-icon>
            </template>
            <template v-slot:append>
              <v-icon
                small
                color="#A4A4AE"
                @click="clearSearch"
                style="cursor: pointer"
              >
                mdi-close
              </v-icon>
            </template>
          </v-text-field>
        </div>
      </v-slide-x-transition>
    </div>

    <!-- Show this when searching -->
    <template v-if="isSearching && searchQuery">
      <div class="search-results">
        <div
          v-for="site in filteredSites"
          :key="site.id"
          class="search-result-group"
        >
          <div v-if="site.projectName" class="search-result-project">
            {{ site.projectName }}
          </div>
          <v-list-item
            :to="'/site/' + site.id"
            class="navigation-sites__list-item"
            :class="{ _active: isActive(site) }"
          >
            <v-tooltip right :disabled="!isNavDrawerMiniVariant">
              <template #activator="{ on, attrs }">
                <div class="site-icon-wrapper mr-3" v-bind="attrs" v-on="on">
                  <template v-if="getSiteIcon(site).type === 'icon'">
                    <v-icon class="site-default-icon">
                      {{ getSiteIcon(site).name }}
                    </v-icon>
                  </template>
                  <template v-else>
                    <img
                      :src="getSiteIcon(site).src"
                      :alt="site.url"
                      class="site-favicon"
                      @error="onImageError($event, site)"
                    />
                  </template>
                  <div
                    class="status-dot"
                    :class="{
                      'status-live': site.kind === 'site',
                      'status-plugin': site.kind === 'plugin',
                    }"
                  ></div>
                </div>
              </template>
              <span>{{ formatSiteUrl(site.url) }}</span>
            </v-tooltip>

            <v-tooltip top :disabled="isNavDrawerMiniVariant">
              <template #activator="{ on, attrs }">
                <span
                  class="site-name"
                  :class="{ _mini: isNavDrawerMiniVariant }"
                  v-bind="attrs"
                  v-on="on"
                >
                  {{ formatSiteUrl(site.url) }}
                </span>
              </template>
              <span>{{ formatSiteUrl(site.url) }}</span>
            </v-tooltip>

            <v-tooltip top>
              <template #activator="{ on, attrs }">
                <v-btn
                  @click.stop="openSiteUrl(site)"
                  text
                  v-bind="attrs"
                  v-on="on"
                  icon
                  x-small
                  class="navigation-sites__action-btn"
                  :class="{ _mini: isNavDrawerMiniVariant }"
                >
                  <the-icon icon="arrow-up-and-right" />
                </v-btn>
              </template>
              <span>Open Site</span>
            </v-tooltip>
          </v-list-item>
        </div>
      </div>
    </template>

    <!-- Show regular list when not searching -->
    <template v-else>
      <div
        v-if="showOrgMemberEmptyState"
        class="the-navigation__empty-state pa-4 mx-2 mb-2"
      >
        <p class="the-navigation__empty-state-title mb-1">
          {{ projectTerms.notAddedYet }}
        </p>
        <p class="the-navigation__empty-state-text mb-0">
          Contact your organisation admin to get access.
        </p>
      </div>

      <v-list-group
        v-for="project in projectsArray"
        :key="project.id"
        v-model="listGroups[project.id]"
        class="the-navigation__projects"
        :class="{
          _active: isProjectActive(project),
          _small: isNavDrawerMiniVariant,
          '': !isNavDrawerMiniVariant,
        }"
        :prepend-icon="!isNavDrawerMiniVariant ? 'mdi-menu-right' : ''"
        sub-group
        eager
      >
        <template v-slot:activator>
          <v-list-item
            @click.stop="openProject(project)"
            inactive
            class="the-navigation__head"
            :class="{ 'the-navigation__head--drag-over': dragOverProject && dragOverProject.id === project.id }"
            @dragenter="onProjectHeaderDragEnter($event, project)"
            @dragover.prevent
            @dragleave="onProjectHeaderDragLeave($event, project)"
            @drop.prevent="onProjectHeaderDrop($event, project)"
          >
            <v-list-item-icon class="the-navigation__project-icon">
              <v-tooltip top>
                <template #activator="{ on, attrs }">
                  <img v-on="on" v-if="project.image" :src="project.image" />
                  <v-icon v-on="on" v-else :color="project.iconColor"
                    >mdi-{{ project.icon }}</v-icon
                  >
                </template>
                <span> {{ project.name }}</span>
              </v-tooltip>
            </v-list-item-icon>
            <v-list-item-content class="the-navigation__project_title_content">
              <v-list-item-title>
                <span class="the-navigation__project_title">
                  {{ project.name }}
                </span>
              </v-list-item-title>
            </v-list-item-content>
            <v-tooltip top v-if="canCreateSiteInProject(project) && hasValidSubscription">
              <template #activator="{ on, attrs }">
                <v-icon
                  v-if="!siteLimitReached"
                  v-on="on"
                  right
                  class="the-navigation__add_site_to_project_icon"
                  medium
                  @click.stop="createSite(project.id)"
                >
                  mdi-plus
                </v-icon>
              </template>
              <span> Create Site in Project </span>
            </v-tooltip>
          </v-list-item>
        </template>

        <draggable
          v-model="project['allObjects']"
          group="sites"
          @start="onDragStart($event, project['allObjects'])"
          @end="onDragEnd"
          @change="handleChangePosition($event, project['allObjects'], project)"
        >
          <div v-if="project['allObjects'].length == 0">
            <v-list-item class="the-navigation__project">
              <v-list-item-content>
                <v-list-item-title
                  class="the-navigation__sub-list-item-name ml-1"
                >
                  {{
                    canCreateSiteInProject(project)
                      ? "I'm empty. Create a site."
                      : projectParticipantEmptySitesMessage(project)
                  }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </div>

          <div
            v-for="site in project['allObjects']"
            :key="project.id + 'obj' + site.id"
            @click.stop="moveToSite(site)"
            class="the-navigation__project"
            :class="{
              _active: site.id == selectedSite,
            }"
          >
            <v-tooltip right :disabled="!isNavDrawerMiniVariant">
              <template #activator="{ on, attrs }">
                <div class="site-icon-wrapper mr-3" v-bind="attrs" v-on="on">
                  <template v-if="getSiteIcon(site).type === 'icon'">
                    <v-icon class="site-default-icon">
                      {{ getSiteIcon(site).name }}
                    </v-icon>
                  </template>
                  <template v-else>
                    <img
                      :src="getSiteIcon(site).src"
                      :alt="site.url"
                      class="site-favicon"
                      @error="onImageError($event, site)"
                    />
                  </template>
                  <div
                    class="status-dot"
                    :class="{
                      'status-live': site.kind === 'site',
                      'status-plugin': site.kind === 'plugin',
                    }"
                  ></div>
                </div>
              </template>
              <span>{{ formatSiteUrl(site.url) }}</span>
            </v-tooltip>

            <v-tooltip top :disabled="isNavDrawerMiniVariant">
              <template #activator="{ on, attrs }">
                <span
                  class="site-name"
                  :class="{ _mini: isNavDrawerMiniVariant }"
                  v-bind="attrs"
                  v-on="on"
                >
                  {{ formatSiteUrl(site.url) }}
                </span>
              </template>
              <span>{{ formatSiteUrl(site.url) }}</span>
            </v-tooltip>

            <v-tooltip top>
              <template #activator="{ on, attrs }">
                <v-btn
                  @click.stop="openSiteUrl(site)"
                  text
                  v-bind="attrs"
                  v-on="on"
                  icon
                  x-small
                  class="the-navigation__sub-arrow"
                >
                  <the-icon icon="arrow-up-and-right" />
                </v-btn>
              </template>
              <span>Open Site</span>
            </v-tooltip>
          </div>
        </draggable>
      </v-list-group>

      <!-- Add divider if we have both projects and unassigned sites -->
      <v-divider
        v-if="projectsArray.length && sitesUnassigned.length"
        class="navigation-sites__divider my-2"
      />

      <draggable
        v-model="sitesArray"
        group="sites"
        tag="div"
        class="navigation-sites"
        :class="{ _small: isNavDrawerMiniVariant }"
        @start="onDragStart($event, sitesArray)"
        @end="onDragEnd"
        @change="handleChangePosition($event, sitesArray, null)"
      >
        <v-list-item
          v-for="site in sitesArray"
          :key="site.id"
          :to="'/site/' + site.id"
          class="navigation-sites__list-item"
          :class="{ _active: isActive(site) }"
        >
          <v-tooltip right :disabled="!isNavDrawerMiniVariant">
            <template #activator="{ on, attrs }">
              <div class="site-icon-wrapper mr-3" v-bind="attrs" v-on="on">
                <template v-if="getSiteIcon(site).type === 'icon'">
                  <v-icon class="site-default-icon">
                    {{ getSiteIcon(site).name }}
                  </v-icon>
                </template>
                <template v-else>
                  <img
                    :src="getSiteIcon(site).src"
                    :alt="site.url"
                    class="site-favicon"
                    @error="onImageError($event, site)"
                  />
                </template>
                <div
                  class="status-dot"
                  :class="{
                    'status-live': site.kind === 'site',
                    'status-plugin': site.kind === 'plugin',
                  }"
                ></div>
              </div>
            </template>
            <span>{{ formatSiteUrl(site.url) }}</span>
          </v-tooltip>

          <v-tooltip top :disabled="isNavDrawerMiniVariant">
            <template #activator="{ on, attrs }">
              <span
                class="site-name"
                :class="{ _mini: isNavDrawerMiniVariant }"
                v-bind="attrs"
                v-on="on"
              >
                {{ formatSiteUrl(site.url) }}
              </span>
            </template>
            <span>{{ formatSiteUrl(site.url) }}</span>
          </v-tooltip>

          <v-tooltip top>
            <template #activator="{ on, attrs }">
              <v-btn
                @click.stop="openSiteUrl(site)"
                text
                v-bind="attrs"
                v-on="on"
                icon
                x-small
                class="navigation-sites__action-btn"
                :class="{ _mini: isNavDrawerMiniVariant }"
              >
                <the-icon icon="arrow-up-and-right" />
              </v-btn>
            </template>
            <span>Open Site</span>
          </v-tooltip>
        </v-list-item>
      </draggable>
    </template>
  </v-list>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import Avatar from 'vue-avatar'
import moment from 'moment'
import { Site as SiteResource } from '@/resources/forge'
import draggable from 'vuedraggable'
import {
  MODAL_CREATE_PROJECT,
  MODAL_CREATE_SITE,
  MODAL_CREATE_ORGANISATION,
  MODAL_ALERT,
} from '@/components/Modals'
import NavigationSites from '@/components/TheNavigation/NavigationSites'
import {
  canCreateProject,
  canCreateSiteInProject,
  EFFECTIVE_ROLE,
  getProjectRole,
  isOrgMember,
} from '@/utils/membershipPermissions'

export default {
  name: 'NavigationClientList',
  components: { Avatar, draggable, NavigationSites },
  data() {
    let activeOrg = this.$store.state.organisations.current
      ? this.$store.state.organisations.current.id
      : 0
    return {
      activeOrganisation: activeOrg,
      listGroups: {},
      projectsArray: [],
      sitesArray: [],
      searchQuery: '',
      isSearching: false,
      showSearchIcon: false,
      failedImages: new Set(),
      isDragging: false,
      draggingItem: null,
      dragOverProject: null,
      dragOpenTimer: null,
    }
  },
  computed: {
    ...mapGetters('organisations', ['projectTerms']),
    ...mapState({
      user: ({ user }) => user.current,
      projects: ({ projects }) => projects.list,
      sites: ({ sites }) => sites.list,
      organisations: ({ organisations }) => organisations.list,
      isNavDrawerMiniVariant: ({ application }) =>
        application.isNavDrawerMiniVariant,
    }),
    getSiteIcon() {
      return (site) => {
        // Check plugin logo first
        if (site.kind === 'plugin' && site.publisherInfo?.logo_url) {
          // If this image has failed before, use fallback
          if (this.failedImages.has(site.publisherInfo.logo_url)) {
            return {
              type: 'icon',
              name: 'mdi-puzzle',
            }
          }
          return {
            type: 'image',
            src: site.publisherInfo.logo_url,
          }
        }
        // Check site favicon
        if (site.image && site.image !== '') {
          // If this image has failed before, use fallback
          if (this.failedImages.has(site.image)) {
            return {
              type: 'icon',
              name: site.kind === 'plugin' ? 'mdi-puzzle' : 'mdi-web',
            }
          }
          return {
            type: 'image',
            src: site.image,
          }
        }
        // Fallback to icon
        return {
          type: 'icon',
          name: site.kind === 'plugin' ? 'mdi-puzzle' : 'mdi-web',
        }
      }
    },
    selectedSite() {
      if (this.$route.path.includes('/site/')) return this.$route.params.id
    },
    sitesUnassigned() {
      return this.productionSites.filter((s) => !s.projectId)
    },
    forgeSites() {
      return this.sitesUnassigned.filter((s) => s.kind == 'site')
    },
    canManage() {
      if (this.$store.state.organisations.current.id == 0) return true
      return this.$store.state.organisations.current.subscription_active
    },
    showOrgMemberEmptyState() {
      return (
        isOrgMember(this.$store.state.organisations.current) &&
        !this.projectsArray.length
      )
    },
    canCreateProjectNav() {
      if (!this.canManage || !this.hasValidSubscription) return false
      return canCreateProject(this.$store.state.organisations.current)
    },
    forgePlugins() {
      return this.sitesUnassigned.filter((s) => s.kind == 'plugin')
    },
    canCreateOrg() {
      return true  // Show to all users, but gate the action
    },
    canActuallyCreateOrg() {
      return this.user.isPaid
    },
    hasValidSubscription() {
      const user = this.user
      return (
        user.isPaid || ['iron', 'bronze', 'copper', 'lead'].includes(user.plan_id)
      )
    },
    objMaxSites() {
      if (this.$store.state.organisations.current.id == 0)
        return this.user.maximum_number_of_sites
      else return this.$store.state.organisations.current.maximum_sites
    },
    objSites() {
      if (this.$store.state.organisations.current.id == 0)
        return this.user.sites_count
      else return this.$store.state.organisations.current.sites_count
    },
    productionSites() {
      return this.sites.filter((s) => s.mode == 'production')
    },
    resourceTypes() {
      return [
        { type: 'sites', text: 'Sites' },
        { type: 'plugins', text: 'Plugins' },
      ]
    },
    orgSettingsAvailable() {
      return this.$store.state.organisations.current.id != 0
    },
    organisationId: {
      get() {
        return this.$store.state.organisations.current
          ? this.$store.state.organisations.current.id
          : null
      },
    },
    avatar() {
      if (this.user.avatar) return this.user.avatar
      return require('@/assets/avatar-placeholder.svg')
    },
    siteLimitReached() {
      if (this.$store.state.organisations.current.id == 0)
        return this.user.maximum_number_of_sites <= this.productionSites.length
      else
        return (
          this.$store.state.organisations.current.maximum_sites <=
          this.$store.state.organisations.current.sites_count
        )
    },
    filteredSites() {
      const query = this.searchQuery.toLowerCase()
      const results = []

      // Search in project sites
      this.projectsArray.forEach((project) => {
        project.allObjects.forEach((site) => {
          if (this.formatSiteUrl(site.url).toLowerCase().includes(query)) {
            results.push({
              ...site,
              projectName: project.name,
            })
          }
        })
      })

      // Search in unassigned sites
      this.sitesUnassigned.forEach((site) => {
        if (this.formatSiteUrl(site.url).toLowerCase().includes(query)) {
          results.push({
            ...site,
            projectName: null,
          })
        }
      })

      return results
    },
  },
  mounted() {
    this.projectsArray = this.filteredProjectsArray(
      _.cloneDeep(this.$store.state.projects.list)
    )
    this.sitesArray = this.filteredSitesArray(
      _.cloneDeep(this.$store.state.sites.list)
    )
    if (this.$store.state.organisations.current.id == 0) return

    if (!this.$store.state.organisations.current.subscription_active) {
      this.showOrganisationSubscriptionExpired()
    }
  },
  watch: {
    '$route.params.id'() {
      if (this.$route.matched[0].name == 'site' && this.activeSite)
        this.$set(this.listGroups, this.activeSite.projectId, true)
      if (this.$route.matched[0].name == 'project' && this.activeProject)
        this.$set(this.listGroups, this.activeProject.id, true)
    },
    '$store.state.sites.list': {
      handler(newVal, oldVal) {
        this.sitesArray = this.filteredSitesArray(_.cloneDeep(newVal))
        this.loading = false
      },
      deep: true,
    },
    '$store.state.projects.list': {
      handler(newVal, oldVal) {
        this.projectsArray = this.filteredProjectsArray(_.cloneDeep(newVal))
        this.sitesArray = this.filteredSitesArray(
          _.cloneDeep(this.$store.state.sites.list)
        )
        this.loading = false
      },
      deep: true,
    },
  },
  methods: {
    ...mapMutations('application', ['toggleisNavDrawerMiniVariant']),
    ...mapActions('application', ['logOut']),
    formatSiteUrl(url) {
      return url ? url.replace('.getforge.io', '') : ''
    },
    isProjectActive(project) {
      if (!this.$route.matched[0]) return false
      if (this.$route.matched[0].name == 'site')
        return this.activeSite.projectId == project.id
      if (this.$route.matched[0].name == 'project')
        return this.activeProject.id == project.id
    },
    openProject(project) {
      this.$router.push('/project/' + project.id)
    },
    moveToSite(site) {
      this.$router.push('/site/' + site.id)
    },
    showOrganisationSubscriptionExpired() {
      this.$store.commit('application/openModal', {
        component: MODAL_ALERT,
        props: {
          title: 'Subscription Expired',
          text: 'To continue use Forge features please select a subscription.',
          actionBtnLabel: 'OK',
        },
      })
    },
    handleChangePosition(event, list, project) {
      if (event.added && this.canManage) {
        let { newIndex, element } = event.added
        let validated = true
        let projectOwner = 0
        if (this.$store.state.organisations.current.id == 0 && project)
          projectOwner = project.user_id
        else if (this.$store.state.organisations.current.id != 0)
          projectOwner = this.$store.state.organisations.current.user_id
        let validatedMessage = 'You should be the owner of a site and a project'
        let validatedChangeOwner = false
        if (!project && !element) validated = false
        else if (
          project &&
          (projectOwner != this.user.id || element.userId != this.user.id)
        )
          validated = false
        else if (!project && this.user.id != element.userId) validated = false
        if (
          project &&
          element &&
          projectOwner != this.user.id &&
          element.userId == this.user.id
        ) {
          validatedChangeOwner = true
          validated = true
        }
        if (validated && !validatedChangeOwner) {
          const moveToId = project ? project.id : null
          let moveToName = project ? ' to ' + project.name : ' out from project'
          this.$store.commit('application/openModal', {
            component: MODAL_ALERT,
            props: {
              title: 'Site Move',
              text: 'Are you want to move ' + element.url + moveToName + ' ?',
              actionBtnLabel: 'Move',
              showCancelBtn: true,
              action: () => {
                this.$store
                  .dispatch('sites/moveSite', {
                    id: element.id,
                    project_id: moveToId,
                  })
                  .then(() => {
                    return true
                  })
              },
              cancelAction: () => {
                this.resetArrays()
              },
            },
          })
        } else if (validated && validatedChangeOwner) {
          let app_url = location.protocol + '//' + location.host
          let params = {
            new_owner_id: project.user_id,
            app_url: app_url,
            project_id: project.id,
          }
          this.$store.commit('application/openModal', {
            component: MODAL_ALERT,
            props: {
              title: 'Change site owner to project owner',
              text: 'Are you sure? To project owner will be send an email to confirm change.',
              actionBtnLabel: 'Change',
              showCancelBtn: true,
              action: () => {
                SiteResource.changeSiteOwner({ id: element.id }, params).catch(
                  (e) => {
                    setTimeout(() => {
                      this.changeOwnerMessage = e.body.message
                      this.changeOwnerFailed = true
                    }, 1800)
                  }
                )
              },
              cancelAction: () => {
                this.resetArrays()
              },
            },
          })
        } else {
          this.$store.commit('application/openModal', {
            component: MODAL_ALERT,
            props: {
              title: 'Site Move',
              text: validatedMessage,
              actionBtnLabel: 'Close',
            },
          })
          this.resetArrays()
        }
      }
    },
    resetArrays() {
      this.projectsArray = this.filteredProjectsArray(
        _.cloneDeep(this.$store.state.projects.list)
      )
      this.sitesArray = this.filteredSitesArray(
        _.cloneDeep(this.$store.state.sites.list)
      )
    },
    onDragStart(event, list) {
      this.isDragging = true
      this.draggingItem = list[event.oldIndex] || null
    },
    onDragEnd() {
      this.isDragging = false
      this.draggingItem = null
      this.dragOverProject = null
      clearTimeout(this.dragOpenTimer)
    },
    onProjectHeaderDragEnter(event, project) {
      if (!this.isDragging || !this.draggingItem) return
      clearTimeout(this.dragOpenTimer)
      this.dragOverProject = project
      this.dragOpenTimer = setTimeout(() => {
        this.$set(this.listGroups, project.id, true)
        this.dragOverProject = null
      }, 600)
    },
    onProjectHeaderDragLeave(event, project) {
      if (!this.dragOverProject || this.dragOverProject.id !== project.id) return
      if (event.currentTarget.contains(event.relatedTarget)) return
      clearTimeout(this.dragOpenTimer)
      this.dragOverProject = null
    },
    onProjectHeaderDrop(event, project) {
      clearTimeout(this.dragOpenTimer)
      this.dragOverProject = null
      if (!this.draggingItem) return
      this.handleChangePosition(
        { added: { element: this.draggingItem, newIndex: 0 } },
        project.allObjects,
        project
      )
    },
    canCreateSiteInProject(project) {
      if (!this.canManage) return false
      return canCreateSiteInProject(
        this.$store.state.organisations.current,
        getProjectRole(project)
      )
    },
    projectParticipantEmptySitesMessage(project) {
      if (getProjectRole(project) === EFFECTIVE_ROLE.PROJECT_MEMBER) {
        return this.projectTerms.notAddedToSiteInContainer
      }
      return this.projectTerms.noSitesInContainer
    },
    filteredObjects(sites) {
      sites = sites.filter((site) => site !== undefined)
      let prodSites = sites.filter((s) => s.mode == 'production')
      prodSites = _.uniqBy(prodSites, 'id')

      prodSites = prodSites.map((site) => {
        const fullSiteData = this.sites.find((s) => s.id === site.id)
        return { ...fullSiteData, ...site }
      })

      const itemsOnTop = prodSites.filter((site) => site.kind == 'site')
      const itemsOnBottom = prodSites.filter((site) => site.kind == 'plugin')
      return [...itemsOnTop, ...itemsOnBottom]
    },
    filteredSitesArray(sites) {
      sites = sites.filter((s) => s.mode == 'production' && !s.projectId)

      sites = sites.map((site) => {
        const fullSiteData = this.sites.find((s) => s.id === site.id)
        return { ...fullSiteData, ...site }
      })

      const itemsOnTop = sites.filter((site) => site.kind == 'site')
      const itemsOnBottom = sites.filter((site) => site.kind == 'plugin')
      return [...itemsOnTop, ...itemsOnBottom]
    },
    filteredProjectsArray(projects) {
      return projects.map((project) => {
        return { ...project, allObjects: this.filteredObjects(project.allObjects || []) }
      })
    },
    initials(username) {
      username[0].toUpperCase()
    },
    openSiteUrl(site) {
      window.open('http://' + site.url, '_blank')
    },

    createOrganisation() {
      if (this.canActuallyCreateOrg) {
        this.$store.commit('application/openModal', {
          component: MODAL_CREATE_ORGANISATION,
        })
      } else {
        // Show upgrade prompt for trial users
        this.$store.commit('application/openModal', {
          component: MODAL_ALERT,
          props: {
            title: 'Unlock Team Workspaces',
            text: `
              <div class="team-workspace-benefits">
                <div class="benefits-intro">
                  <p>Team Workspaces help you collaborate with your team and manage projects together.</p>
                </div>
                
                <div class="benefits-list">
                  <div class="benefit-item">
                    <div class="benefit-icon">
                      <i class="mdi mdi-account-multiple"></i>
                    </div>
                    <div class="benefit-content">
                      <strong>Team Collaboration</strong>
                      <span>Invite team members and manage permissions</span>
                    </div>
                  </div>
                  
                  <div class="benefit-item">
                    <div class="benefit-icon">
                      <i class="mdi mdi-folder-multiple"></i>
                    </div>
                    <div class="benefit-content">
                      <strong>Shared Projects</strong>
                      <span>Organize and share projects across your team</span>
                    </div>
                  </div>
                  
                  <div class="benefit-item">
                    <div class="benefit-icon">
                      <i class="mdi mdi-shield-check"></i>
                    </div>
                    <div class="benefit-content">
                      <strong>Advanced Security</strong>
                      <span>Enhanced security features and access controls</span>
                    </div>
                  </div>
                  
                  <div class="benefit-item">
                    <div class="benefit-icon">
                      <i class="mdi mdi-chart-line"></i>
                    </div>
                    <div class="benefit-content">
                      <strong>Team Analytics</strong>
                      <span>Track team performance and project metrics</span>
                    </div>
                  </div>
                </div>
                
                <div class="enterprise-section">
                  <div class="enterprise-content">
                    <div class="enterprise-icon">
                      <i class="mdi mdi-office-building"></i>
                    </div>
                    <div class="enterprise-text">
                      <strong>Need Enterprise features?</strong>
                      <span>Advanced security, SSO, custom integrations, and dedicated support for larger teams.</span>
                    </div>
                    <div class="enterprise-cta">
                      <button class="enterprise-demo-btn" onclick="window.open('https://getforge.com/solutions/enterprise-demo.html', '_blank')">
                        Book Demo
                      </button>
                    </div>
                  </div>
                </div>
                
                <div class="upgrade-note">
                  <p>Upgrade to a paid plan to create your first Team Workspace.</p>
                </div>
              </div>
            `,
            actionBtnLabel: 'Upgrade Plan',
            showCancelBtn: true,
            withSpiner: false,
            action: () => {
              this.$router.push('/profile/billing')
            },
          },
        })
      }
    },

    async setActiveOrganisation(id) {
      if (id == -1) {
        this.createOrganisation()
        this.activeOrganisation = this.organisations.find(
          (org) => org.id == this.$store.state.organisations.current.id
        )
      } else {
        await this.$store.dispatch('organisations/setCurrent', id, {
          root: true,
        })
        location = '/'
      }
    },
    createSite(project_id = null) {
      if (project_id && !this.canCreateSiteInProject(
        this.$store.getters['projects/findById'](project_id)
      )) {
        return
      }
      // Check if user has valid subscription
      if (!this.hasValidSubscription) {
        this.$router.push({
          name: 'profile_billing',
          query: { redirect: this.$route.fullPath },
        })
        return
      }
      this.$store.commit('application/openModal', {
        component: MODAL_CREATE_SITE,
        props: {
          projectId: project_id,
        },
      })
    },
    openOrganisationSettings() {
      this.$router.push(`/organisation/${this.organisationId}`)
    },
    createProject() {
      if (!this.canCreateProjectNav) return
      // Check if user has valid subscription
      if (!this.hasValidSubscription) {
        this.$router.push({
          name: 'profile_billing',
          query: { redirect: this.$route.fullPath },
        })
        return
      }
      this.$store.commit('application/openModal', {
        component: MODAL_CREATE_PROJECT,
      })
    },
    isActive(site) {
      return this.selectedSite === site.id
    },
    startSearch() {
      this.isSearching = true
      this.$nextTick(() => {
        this.$refs.searchInput.focus()
      })
    },
    clearSearch() {
      this.searchQuery = ''
      this.isSearching = false
    },
    onSearchBlur() {
      if (!this.searchQuery) {
        this.isSearching = false
      }
    },
    onImageError(event, site) {
      // Get the failed image URL
      const failedUrl = event.target?.src
      
      if (failedUrl) {
        // Add to failed images set
        this.failedImages.add(failedUrl)
        
        // Also check and add the original URLs from site data
        if (site.image && failedUrl.includes(site.image)) {
          this.failedImages.add(site.image)
        }
        if (site.publisherInfo?.logo_url && failedUrl.includes(site.publisherInfo.logo_url)) {
          this.failedImages.add(site.publisherInfo.logo_url)
        }
        
        // Force re-render by updating the site's display (Vue reactivity)
        this.$forceUpdate()
        
        console.warn(`Failed to load favicon for ${site.url}, using fallback icon`)
      }
    },
  },
}
</script>
<style lang="scss">
$style: the-navigation;

.v-text-field > .v-input__control > .v-input__slot:after {
  border-style: unset !important;
}

.v-list-item--active .org_select {
  width: 100%;
}

.v-list-item__icon {
  margin-right: 5px !important;
}
.v-list-group--sub-group .v-list-group__header {
  padding-left: 0px !important;
}

.#{$style} {
  padding: 82px 24px 191px;
  &.v-navigation-drawer--mini-variant {
    overflow: initial;
  }
  &__img_logo {
    width: 24px;
    height: 24px;
    display: inline-block;
    vertical-align: middle;
  }
  &__item_name {
    margin-left: 10px;
    display: inline-block;
  }
  &__project-icon.v-list-item__icon {
    margin-right: 8px !important;
  }
  &__project_title {
    overflow: hidden;
    min-width: 50%;
    display: inline-block;
    vertical-align: middle;
  }

  &.v-navigation-drawer {
    background-color: $dark-bg-color;
  }
  &__header {
    position: absolute;
    top: 16px;
    left: 6px;
    right: 0;
  }
  &__icon {
    cursor: pointer;
    transition: filter 0.2s ease;
    &:hover {
      filter: brightness(1.2);
    }
  }
  &__toggle-btn.v-icon {
    position: absolute;
    right: 22px;
    top: 13px;
    border: 1px solid $N5;
    border-radius: 4px;
    z-index: 1;
    background-color: $dark-bg-color;
    &._mini {
      right: -10px;
    }
    &:focus::after {
      content: none;
    }
    &:hover {
      border-color: $N3;
    }
  }
  &__list {
    padding: 0;
  }
  &__divider {
    margin: 0 0 24px;
    &.v-divider {
      background-color: $N5;
    }
  }
  &__list-item {
    margin-bottom: 20px;
  }
  &__footer {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 0 24px 40px;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    max-width: 100%;
    &._small {
      padding: 0 28px 40px;
    }
  }
  &__footer-btn {
    &.v-btn {
      margin-bottom: 20px;
      padding: 0 !important;
    }
  }
  &__footer-link {
    &.v-size--default {
      font-size: 16px;
      padding: 0 !important;
    }
    font-weight: 600;
  }
  &__footer-icon {
    margin-right: 14px;
    &._margin-less {
      margin-right: 0;
    }
  }
  &__nav-icon {
    fill: $N2;
  }
  &__nav-content {
    color: $N2;
    font-weight: 500;
    font-size: $H14;
    white-space: nowrap;
  }
  &__list-item {
    &._active {
      color: $white;
      .#{$style}__nav-icon {
        fill: $B1;
      }
      .#{$style}__nav-content {
        color: $B1;
      }
      &:before {
        content: none;
      }
    }
  }
  &__projects {
    &._small {
      padding: 0;
      margin-left: 8px;
    }
    &
      .v-list-group__header
      .v-list-item__icon.v-list-group__header__append-icon {
      display: none;
    }
    & .#{$style}__head {
      color: $N2 !important;
      .v-icon {
        color: inherit;
      }
    }
    &._active {
      & .#{$style}__head {
        color: $white !important;
      }
    }
    & .v-list-item {
      padding: 0;
    }
    .v-list-group__items {
      padding-left: 0;
    }
  }
  &__project {
    cursor: pointer;
    padding: 0 8px;
    min-height: 40px;
    display: flex;
    align-items: center;
    width: 100%;

    &:hover {
      background: #2a293a;

      .#{$style}__sub-arrow {
        opacity: 1;
      }

      .site-name {
        color: white;
      }

      .site-default-icon {
        color: white;
      }
    }

    &._active {
      .site-name {
        color: white;
      }

      .site-default-icon {
        color: white;
      }
    }

    .site-icon-wrapper {
      width: 28px;
      height: 28px;
      margin-left: 4px;
      margin-right: 8px;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;

      .site-default-icon {
        font-size: 20px;
        color: #a4a4ae;
        transition: color 0.2s ease;
      }

      .site-favicon {
        width: 20px;
        height: 20px;
        object-fit: contain;
      }

      .status-dot {
        position: absolute;
        bottom: -2px;
        right: -2px;
        width: 6px;
        height: 6px;
        border-radius: 50%;
        border: 1px solid #1f1e31;

        &.status-live {
          background-color: #4caf50;
        }

        &.status-plugin {
          background-color: #ff9800;
        }
      }
    }

    .site-name {
      font-size: 12px;
      font-weight: 500;
      color: #a4a4ae;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      flex-grow: 1;
      min-width: 0;
      transition: color 0.2s ease;
      margin-right: 4px;
    }

    .#{$style}__sub-arrow {
      opacity: 0;
      margin-left: auto;
      transition: opacity 0.2s ease;
      flex-shrink: 0;
      width: 24px;

      &.theme--dark.v-btn.v-btn--icon {
        color: #a4a4ae;

        &:hover {
          color: white;
        }
      }
    }
  }
  &__sub-list-name {
    &.v-list-item {
      padding-left: 0 8px;
    }
  }
  &__sub-list-item-name {
    font-size: 12px;
    font-weight: 500;
    color: $N2;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding-right: 8px;
  }
  &__sub-arrow {
    &.theme--dark.v-btn.v-btn--icon {
      color: #a4a4ae;

      &:hover {
        color: white;
      }
    }
  }
  &__dot {
    display: inline-block !important;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: $G1;
    margin-right: 8px;
  }

  &__head {
    .the-navigation__add_site_to_project_icon {
      display: none;
      margin-left: auto;
    }
    &:hover {
      .the-navigation__add_site_to_project_icon {
        display: inline-flex;
      }
    }
    &--drag-over {
      background: rgba(255, 255, 255, 0.08) !important;
      border-radius: 4px;
      outline: 1px dashed rgba(255, 255, 255, 0.3);
      outline-offset: -2px;
    }
  }
}
.navigation-sites__list-item {
  padding: 0 8px;
  height: 40px;
  display: flex;
  align-items: center;
  position: relative;
  margin-left: 8px;
  min-width: 0;

  &._active {
    .site-name {
      color: white;
    }

    .site-default-icon {
      color: white;
    }
  }

  &:hover {
    background: #2a293a;

    .site-name {
      color: white;
    }

    .site-default-icon {
      color: white;
    }

    .navigation-sites__action-btn {
      opacity: 1;
    }
  }
}

.navigation-sites__action-btn {
  opacity: 0;
  margin-left: auto;
  color: #a4a4ae;
  transition: opacity 0.2s ease;
  width: 24px;
  flex-shrink: 0;
}

.site-icon-wrapper {
  width: 28px;
  height: 28px;
  margin-left: 4px;
  margin-right: 8px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  .site-default-icon {
    font-size: 20px;
    color: #a4a4ae;
    transition: color 0.2s ease;
  }

  .site-favicon {
    width: 20px;
    height: 20px;
    object-fit: contain;
  }

  .status-dot {
    position: absolute;
    bottom: -2px;
    right: -2px;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    border: 1px solid #1f1e31;

    &.status-live {
      background-color: #4caf50;
    }

    &.status-plugin {
      background-color: #ff9800;
    }
  }
}

.status-dot {
  position: absolute;
  bottom: -2px;
  right: -2px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  border: 1.5px solid #1f1e31;

  &.status-live {
    background-color: #4caf50;
  }

  &.status-plugin {
    background-color: #ff9800;
  }

  &.status-error {
    background-color: #ff5252;
  }
}

.site-name {
  font-size: 12px;
  font-weight: 500;
  color: #a4a4ae;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex-grow: 1;
  min-width: 0;
  transition: all 0.2s ease;
  margin-right: 4px;

  .v-navigation-drawer--mini-variant & {
    opacity: 0;
    width: 0;
  }
}

.the-navigation__projects-header {
  display: flex;
  align-items: center;
  height: 40px;
  margin-bottom: 8px;
  position: relative;

  .projects-title {
    display: flex;
    align-items: center;
    color: #a4a4ae;
    font-size: 12px;
    font-weight: 500;
    padding: 0 8px;
    width: 100%;

    .projects-icon {
      color: #a4a4ae;
      font-size: 20px;
    }

    span {
      transition: opacity 0.2s ease;
    }

    .search-trigger {
      margin-left: auto;
      opacity: 0;
      transition: opacity 0.2s ease;
      cursor: pointer;

      &:hover {
        color: white;
      }
    }

    &:hover .search-trigger {
      opacity: 1;
    }

    .v-navigation-drawer--mini-variant & {
      justify-content: center;
      padding: 0;
      width: 100%;

      span,
      .search-trigger {
        display: none;
      }

      .projects-icon {
        margin: 0;
        display: flex;
        justify-content: center;
        width: 100%;
      }
    }
  }

  .search-container {
    position: absolute;
    left: 0;
    right: 0;
    background: $dark-bg-color;
    z-index: 1;

    .search-input {
      padding: 0 8px;

      ::v-deep .v-input__slot {
        background: transparent !important;
        min-height: 32px !important;
        border: 1px solid #2e2c42;

        &:hover,
        &:focus-within {
          border-color: #a4a4ae;
        }
      }
    }
  }
}

.search-results {
  .search-result-group {
    margin-bottom: 8px;
  }

  .search-result-project {
    font-size: 11px;
    color: #a4a4ae;
    padding: 4px 16px;
    opacity: 0.7;
  }
}

.navigation-sites__divider {
  &.v-divider {
    border-color: #2e2c42 !important;
    margin-left: 8px;
    margin-right: 8px;
  }
}

.add-org-content {
  padding: 0 !important;
  
  .add-org-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    min-height: 24px;
    padding: 8px 0;
  }

  .add-org-text {
    color: white;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.2;
  }

  .upgrade-icon {
    margin-left: 8px;
    flex-shrink: 0;
    cursor: pointer;
    opacity: 0.8;
    transition: opacity 0.2s ease;
    
    &:hover {
      opacity: 1;
    }
  }
}

// Hover effect for the entire item
.v-list-item:hover .add-org-content {
  .upgrade-icon {
    opacity: 1;
    color: #ff9f3a !important;
  }
}

.the-navigation__empty-state {
  border: 1px solid #2e2c42;
  border-radius: 8px;
  background: rgba(31, 30, 49, 0.6);

  &-title {
    color: #fff;
    font-size: 14px;
    font-weight: 500;
  }

  &-text {
    color: #a4a4ae;
    font-size: 13px;
  }
}


</style>
